import { useMutation } from '@tanstack/react-query';
import api from '@/shared/api';
import config from '@/config';
const extractDocumentDataPreview = (documentId) => api.base
    .post(`${config.appUrls.api}/api/DocumentExtraction/extractPreview`, { documentId })
    .then(({ data }) => data);
const useExtractDocumentDataPreview = () => useMutation({
    mutationFn: extractDocumentDataPreview,
});
export default useExtractDocumentDataPreview;
